// extracted by mini-css-extract-plugin
export default {"container":"CustomInput_container__CRiUy","icon":"CustomInput_icon__1neDR","blue":"CustomInput_blue__Vaxfm","red":"CustomInput_red__bB4VE","green":"CustomInput_green__OixzE"};